export default function isBrowserInFullScreenMode() {
    return (
    // Chrome: http://stackoverflow.com/questions/21125337/how-to-detect-if-web-app-running-standalone-on-chrome-mobile
    window.matchMedia('(display-mode: standalone)').matches ||
        // Safari (and others?)
        window.navigator.standalone);
}
